import { authorizedApi } from './index';

export type CreateOrderResponse = {
  mode: string;
  inputMint: string;
  outputMint: string;
  inAmount: string;
  outAmount: string;
  inUsdValue: number;
  outUsdValue: number;
  priceImpact: number;
  swapUsdValue: number;
  otherAmountThreshold: string;
  swapMode: string;
  slippageBps: number;
  priceImpactPct: string;
  routePlan: Array<{
    swapInfo: {
      ammKey: string;
      label: string;
      inputMint: string;
      outputMint: string;
      inAmount: string;
      outAmount: string;
      feeAmount: string;
      feeMint: string;
    };
    percent: number;
    bps: number;
  }>;
  feeMint: string;
  feeBps: number;
  platformFee: {
    amount: string;
    feeBps: number;
  };
  signatureFeeLamports: number;
  signatureFeePayer: string;
  transaction: string;
  gasless: boolean;
  requestId: string;
  totalTime: number;
  taker: string;
  quoteId: string;
  maker: string;
  expireAt: string;
  errorCode: number;
  errorMessage: string;
};

export type ExecuteResponse = {
  status: 'Success' | 'Failed';
  signature: string;
  slot: string;
  error: string;
  code: number;
  totalInputAmount: string;
  totalOutputAmount: string;
  inputAmountResult: string;
  outputAmountResult: string;
  swapEvents: Array<{
    inputMint: string;
    inputAmount: string;
    outputMint: string;
    outputAmount: string;
  }>;
};

type CreateOrderParams = {
  inputMint: string;
  outputMint: string;
  amount: string;
  swapMode?: 'ExactIn' | 'ExactOut';
};

type ExecuteOrderParams = {
  userSignedTransaction: string;
  requestId: string;
};

export const ultraApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.query<CreateOrderResponse, CreateOrderParams>({
      query: ({ inputMint, outputMint, amount, swapMode = 'ExactIn' }) => ({
        url: `/ultra/create-order?inputMint=${inputMint}&outputMint=${outputMint}&amount=${amount}&swapMode=${swapMode}`,
        method: 'GET',
      }),
    }),
    executeOrder: builder.query<ExecuteResponse, ExecuteOrderParams>({
      query: ({ userSignedTransaction, requestId }) => ({
        url: `/ultra/execute-order`,
        method: 'POST',
        body: {
          userSignedTransaction,
          requestId,
        },
      }),
    }),
  }),
});

export const {
  useCreateOrderQuery,
  useExecuteOrderQuery,
  useLazyCreateOrderQuery,
  useLazyExecuteOrderQuery,
} = ultraApi;
